import { Axios } from '@/config/axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  getAccounts({commit}) {
    return new Promise((resolve, reject) => {
      Axios.get('/api/accounts/get-accounts')
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setAccount({commit}, data) {
    return new Promise((resolve, reject) => {
      Axios.post('/api/accounts/set-account', data)
        .then((response) => {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('user.role', response.data.data.role);
          localStorage.setItem('user.id', response.data.data.id);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
